import MRNLinesList from '../../../../components/HSEQ/MRN/Lines/MRNLinesList'
import MRNLinesModal from '../../../../components/HSEQ/MRN/Lines/MRNLinesModal'
import React, { Fragment } from 'react'

function MRNLines(props) {
  return (
    <Fragment>
      <MRNLinesModal {...props} />
      <MRNLinesList {...props} />
    </Fragment>
  )
}

export default MRNLines
